import React, { useContext, useEffect, useReducer, useState } from "react";
import "../../css_files/Master/AddCustomerMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import AddCustomerAddress from "./AddCustomerAddress";
import AddCustomerBoiler from "./AddCustomerBoiler";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddCustomerMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  customerupdatedata,
}) {
  const [customerData, setCustomerData] = useState({
    OrgName: triggerupdate ? customerupdatedata?.orgName : "",
    Description: triggerupdate ? customerupdatedata?.description : "",
    Code: triggerupdate ? customerupdatedata?.pricing?.id : "",
    GSTNumber: triggerupdate ? customerupdatedata?.gstNumber : "",
  });
  const [addressState, addressdispatch] = useReducer(addressReducer, []);
  const [boilerState, boilerDispatch] = useReducer(boilerReducer, []);
  const [contactState, contactDispatch] = useReducer(contactReducer, []);

  useEffect(() => {
    if (triggerupdate) {
      contactDispatch({ type: "update" });
      addressdispatch({ type: "update" });
      boilerDispatch({ type: "update" });
    } else {
      contactDispatch({ type: "reset" });
      addressdispatch({ type: "reset" });
      boilerDispatch({ type: "reset" });
    }
  }, [triggerupdate, customerupdatedata]);

  const [customerPricingCodes, setCustomerPricingCodes] = useState([]);
  const [reloadDropdown, setreloadDropdown] = useState(false);
  const [rotatedropdownicon, setrotatedropdownicon] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const { setExpiredSession } = useContext(triggerscroll);

  function addressReducer(state, action) {
    switch (action.type) {
      case "field":
        return state.map((x, i) =>
          i === action.index
            ? {
                ...x,
                [action.name]: action.value,
              }
            : x
        );
      case "decrement":
        return state.filter((x, i) => i !== action.index);
      case "increment":
        return [
          ...state,
          {
            addressType: "",
            address1: "",
            address2: "",
            country: "",
            city: null,
            pincode: null,
            state: null,
            officeName: "",
            factoryName: "",
            stateName: null,
            cityName: null,
            from: "",
            latitude: null,
            longitude: null,
          },
        ];
      case "update":
        return customerupdatedata?.addresses ?? [];
      case "reset":
        return [];
      default:
        return state;
    }
  }

  function boilerReducer(state, action) {
    switch (action.type) {
      case "field":
        return state.map((x, i) =>
          i === action.index
            ? {
                ...x,
                [action.name]: action.value,
              }
            : x
        );
      case "decrement":
        return state.filter((x, i) => i !== action.index);
      case "increment":
        return [
          ...state,
          {
            boilerHead: "",
            boilerSeries: "",
            purchaseDate: null,
            srNo: null,
          },
        ];
      case "update":
        return customerupdatedata?.customerBoilers ?? [];
      case "reset":
        return [];
      default:
        return state;
    }
  }

  function contactReducer(state, action) {
    switch (action.type) {
      case "field":
        return state.map((x, i) =>
          i === action.index
            ? {
                ...x,
                [action.name]: action.value,
              }
            : x
        );
      case "decrement":
        return state.filter((x, i) => i !== action.index);
      case "increment":
        return [
          ...state,
          {
            salutation: "Mr.",
            name: "",
            designation: "",
            phoneNumber: "",
            email: "",
          },
        ];
      case "update":
        return customerupdatedata?.contactCentres ?? [];
      case "reset":
        return [];
      default:
        return state;
    }
  }

  useEffect(() => {
    setrotatedropdownicon(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/CustomerPricing`)
      .then((res) => {
        setCustomerPricingCodes(res.data);
        setrotatedropdownicon(false);
      })
      .catch((err) => {
        console.log(err);
        setrotatedropdownicon(false);
      });
  }, [reloadDropdown]);

  function handleSubmit() {
    setloading(true);
    const payload = {
      ...customerData,

      Addresses: addressState.map((x) => ({
        ...x,
        stateObj: undefined,
        cityObj: undefined,
        pincode: x.pincode || 0,
      })),
      ContactCentres: contactState,
      CustomerBoilers: boilerState.map((x) => ({
        ...x,
        boiler: undefined,
        boilerSeriess: undefined,
        srNo: x.srNo || 0,
      })),
    };

    if (triggerupdate) {
      payload.customerID = customerupdatedata.id;
    }

    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Customer/${
      triggerupdate ? "UpdateCustomerCommand" : ""
    }`;
    axiosInstance
      .post(URL, payload)
      .then((response) => {
        toast.success(
          triggerupdate ? response.data.message : "Record Added Successfully",
          {
            position: "bottom-center",
            theme: "dark",
          }
        );

        setReload(!reload);
      })
      .catch((err) => {
        if (err.status === 500)
          Swal.fire({
            title: "Errors Occured",
            text: err.response.data.error,
            icon: "error",
          });
        else
          toast.error("Failed to Add Record", {
            position: "bottom-center",
            theme: "dark",
          });
      })
      .finally(() => {
        setloading(false);
        setshowaddform(false);
      });
  }

  return (
    <form
      className="add-customer-master"
      onSubmit={(e) => {
        e.preventDefault();
        let isValid = true;
        const addresses = document.getElementsByClassName(
          "add-customer-address"
        );
        for (let i = 0; i < addresses.length; i++) {
          if (!addresses[i].checkValidity()) {
            addresses[i].reportValidity();
            isValid = false;
          }
        }
        if (isValid) handleSubmit();
      }}
    >
      <blockquote>
        <label>
          Organization/Company Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>

        <input
          required
          type="text"
          placeholder="Enter Organization/Company Name"
          onChange={(e) => {
            setCustomerData({
              ...customerData,
              OrgName: e.target.value?.slice(0, 100),
            });
          }}
          value={customerData.OrgName}
          /*onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^a-zA-Z\s]/g, "")
              .slice(0, 100);
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/Customer/GetCustomerByIdOrName?name=${e.target.value}`
              )
              .then((res) =>
                setMessage("Customer With this Name Already Exists")
              )
              .catch((error) => {
                setMessage("");
              });
          }}*/
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>
      <blockquote>
        <label>GST Number</label>
        <input
          type="text"
          placeholder="Enter GST Number"
          onChange={(e) =>
            setCustomerData({ ...customerData, GSTNumber: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 20);
          }}
          value={customerData.GSTNumber}
        />
      </blockquote>
      <blockquote>
        <label>Description</label>
        <textarea
          placeholder="Description (Maximum 400 Characters)"
          rows={5}
          onChange={(e) =>
            setCustomerData({ ...customerData, Description: e.target.value })
          }
          value={customerData.Description}
          onInput={(e) => (e.target.value = e.target.value.slice(0, 400))}
        ></textarea>
      </blockquote>
      <blockquote>
        <label>
          Customer Pricing{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <select
            required
            onChange={(e) =>
              setCustomerData({ ...customerData, Code: e.target.value })
            }
          >
            <option value="">Select Customer Pricing</option>
            {customerPricingCodes.map((code) => (
              <option value={code.id} selected={customerData.Code === code.id}>
                {code.code}
              </option>
            ))}
          </select>
          <i
            class={`fa-solid fa-rotate-right ${
              rotatedropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() => setreloadDropdown(!reloadDropdown)}
          ></i>
        </aside>
      </blockquote>

      {addressState.length === 0 && (
        <blockquote>
          <aside>
            <label>Add Address</label>
            <i
              class="fa-solid fa-circle-plus"
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => {
                addressdispatch({ type: "increment" });
              }}
            ></i>
          </aside>
        </blockquote>
      )}
      {addressState.map((_, dataindex) => (
        <AddCustomerAddress
          addressindex={dataindex}
          customeraddressdata={addressState}
          dispatch={addressdispatch}
          triggerupdate={triggerupdate}
          customerData={customerData}
        />
      ))}

      {contactState.length === 0 && (
        <blockquote>
          <aside>
            <label>Add Customer POC (Point Of Contact)</label>

            <i
              class="fa-solid fa-circle-plus"
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => {
                contactDispatch({ type: "increment" });
              }}
            ></i>
          </aside>
        </blockquote>
      )}

      {contactState.map((_, dataindex) => (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <label>Customer POC (Point of Contact)</label>
            <blockquote
              style={{
                flexDirection: "row",
                width: "fit-content",
                alignItems: "center",
              }}
            >
              <i
                class="fa-solid fa-circle-minus"
                style={{ fontSize: "2rem", cursor: "pointer" }}
                onClick={() => {
                  contactDispatch({ type: "decrement", index: dataindex });
                }}
              ></i>
              <i
                class="fa-solid fa-circle-plus"
                style={{ fontSize: "2rem", cursor: "pointer" }}
                onClick={() => {
                  contactDispatch({ type: "increment", index: dataindex });
                }}
              ></i>
            </blockquote>
          </div>
          <blockquote>
            <label>
              From{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <aside>
              <mark>
                <input
                  type="radio"
                  name="From"
                  required
                  checked={contactState[dataindex]?.from === "Indian"}
                  onChange={() => {
                    contactDispatch({
                      type: "field",
                      index: dataindex,
                      name: "phoneNumber",
                      value: "",
                    });
                    contactDispatch({
                      type: "field",
                      index: dataindex,
                      name: "from",
                      value: "Indian",
                    });
                  }}
                />
                <p>Indian</p>
              </mark>
              <mark>
                <input
                  type="radio"
                  name="From"
                  required
                  checked={contactState[dataindex]?.from === "Others"}
                  onChange={() => {
                    contactDispatch({
                      type: "field",
                      index: dataindex,
                      name: "phoneNumber",
                      value: "",
                    });
                    contactDispatch({
                      type: "field",
                      index: dataindex,
                      name: "from",
                      value: "Others",
                    });
                  }}
                />
                <p>Others</p>
              </mark>
            </aside>
          </blockquote>
          <blockquote>
            <label>
              Salutation{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <aside>
              <mark>
                <input
                  type="radio"
                  value="Mr."
                  required
                  name={`Salutation${dataindex}`}
                  onChange={(e) => {
                    contactDispatch({
                      type: "field",
                      index: dataindex,
                      name: "salutation",
                      value: e.target.value,
                    });
                  }}
                  checked={contactState[dataindex]?.salutation === "Mr."}
                />
                <p>Mr.</p>
              </mark>
              <mark>
                <input
                  type="radio"
                  value="Mrs."
                  name={`Salutation${dataindex}`}
                  required
                  onChange={(e) => {
                    contactDispatch({
                      type: "field",
                      index: dataindex,
                      name: "salutation",
                      value: e.target.value,
                    });
                  }}
                  checked={contactState[dataindex]?.salutation === "Mrs."}
                />
                <p>Mrs.</p>
              </mark>
            </aside>
          </blockquote>
          <blockquote>
            <label>
              Name{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <input
              type="text"
              required
              placeholder="Enter Name"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 200);
              }}
              onChange={(e) => {
                contactDispatch({
                  type: "field",
                  index: dataindex,
                  name: "name",
                  value: e.target.value,
                });
              }}
              value={contactState[dataindex]?.name}
            />
          </blockquote>
          <blockquote>
            <label>
              Designation{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <input
              type="text"
              required
              placeholder="Enter Designation"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 200);
              }}
              onChange={(e) => {
                contactDispatch({
                  type: "field",
                  index: dataindex,
                  name: "designation",
                  value: e.target.value,
                });
              }}
              value={contactState[dataindex]?.designation}
            />
          </blockquote>
          <blockquote>
            <label>
              Phone Number{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <input
              type="text"
              required
              placeholder={
                contactState[dataindex]?.from === "Others"
                  ? "Enter Phone Number with Country Code (e.g. +123456789012345)"
                  : "Enter Phone Number (10 Digits Excluding Country Code)"
              }
              onInput={(e) => {
                const isOthers = contactState[dataindex]?.from === "Others";

                if (isOthers) {
                  let value = e.target.value.replace(/[^\d+]/g, "");

                  if (value.includes("+")) {
                    value = "+" + value.replace(/\+/g, "");
                  }

                  const digitsOnly = value.replace(/\D/g, "").slice(0, 15);
                  e.target.value = value.startsWith("+")
                    ? `+${digitsOnly}`
                    : digitsOnly;
                } else {
                  e.target.value = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 10);
                }
              }}
              onChange={(e) => {
                contactDispatch({
                  type: "field",
                  index: dataindex,
                  name: "phoneNumber",
                  value: e.target.value,
                });
              }}
              value={contactState[dataindex]?.phoneNumber || ""}
            />
          </blockquote>
          <blockquote>
            <label>
              Email{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <input
              type="email"
              placeholder="Enter Email"
              required
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 200);
              }}
              onChange={(e) => {
                contactDispatch({
                  type: "field",
                  index: dataindex,
                  name: "email",
                  value: e.target.value,
                });
              }}
              value={contactState[dataindex]?.email}
            />
          </blockquote>
        </>
      ))}

      {boilerState.length === 0 && (
        <blockquote>
          <aside>
            <label>Add Customer Boiler</label>
            <i
              class="fa-solid fa-circle-plus"
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => {
                boilerDispatch({ type: "increment" });
              }}
            ></i>
          </aside>
        </blockquote>
      )}
      {boilerState.map((_, dataindex) => (
        <AddCustomerBoiler
          boilerindex={dataindex}
          customerboilerdata={boilerState}
          triggerupdate={triggerupdate}
          dispatch={boilerDispatch}
        />
      ))}
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddCustomerMaster;
